import { gossipTestimonials } from "@/mocks/gossipTestimonials";
import SectionHeading from "@/components/feature/SectionHeading";

export default function TestimonialSection() {
  return (
    <section className="mx-auto max-w-shell px-4 py-14 md:px-6 md:py-16">
      <SectionHeading
        eyebrow="Voices"
        title="读者怎么说"
        description="来自不同使用场景的真实反馈，也是我们判断内容做得好不好的重要依据。"
      />

      <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {gossipTestimonials.map((item) => (
          <figure key={item.name} className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6">
            <i className="ri-double-quotes-l text-2xl text-primary-300" />
            <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{item.quote}</blockquote>
            <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-100 font-heading text-sm font-bold text-accent-800">
                {item.name.slice(0, 1)}
              </span>
              <span>
                <span className="block font-label text-sm font-medium text-foreground-900">{item.name}</span>
                <span className="block text-xs text-foreground-500">{item.role}</span>
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}